import { DateWorkingMode } from '../models/entities/calendar.model';

export const activeDealerCalendar = [
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-14',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-15',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-16',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-07-17',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-18',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-19',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-20',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-21',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-22',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-23',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-07-24',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-25',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-26',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-27',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-28',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-29',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-07-30',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-07-31',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-01',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-02',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-03',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-04',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-05',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-06',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-08-07',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-08',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-09',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-10',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-11',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-12',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-13',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-08-14',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-15',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-16',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-17',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-18',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-19',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-20',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-08-21',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-22',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-23',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-24',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-25',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-26',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-27',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-08-28',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-29',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-30',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-08-31',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-01',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-02',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-03',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-09-04',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-05',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-06',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-07',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-08',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-09',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-10',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-09-11',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-12',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-13',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-14',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-15',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-16',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-17',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-09-18',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-19',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-20',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-21',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-22',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-23',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-24',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-09-25',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-26',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-27',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-28',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-29',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-09-30',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '13:30',
        openingTime: '08:30',
      },
    ],
    date: '2022-10-01',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [],
    date: '2022-10-02',
    dealerOpen: false,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-10-03',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-10-04',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-10-05',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
  {
    available: true,
    businessHoursPeriods: [
      {
        closingTime: '18:00',
        openingTime: '08:30',
      },
    ],
    date: '2022-10-06',
    dealerOpen: true,
    zoneOffSet: '+02:00',
  },
];

export const activeTextCarouselSlideRange = {
  start: 0,
  end: 0,
};

export const rangePicker = {
  enabled: true,
  workingMode: DateWorkingMode.START,
};

export const rentalSlotTimes = {
  start: {
    closingTime: '18:00',
    openingTime: '08:30',
  },
  end: {
    closingTime: '18:00',
    openingTime: '08:30',
  },
};

export const selectedRangeDate = {
  start: new Date('2022-07-04T00:00:00.000Z'),
  end: new Date('2022-07-07T00:00:00.000Z'),
};

export const selectedRangeTime = {
  start: {
    disabled: false,
    value: '08:30',
  },
  end: {
    value: '17:30',
    disabled: false,
  },
  zoneOffSet: '+02:00',
};
